/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_TrInputs */

const en_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const es_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const de_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const zh_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const ar_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const fr_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const vi_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const sw_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const th_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const bs_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const ja_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const ko_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const pt_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const it_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const sv_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const nl_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const da_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const nb_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const fi_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const pl_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const ru_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const tr_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const hi_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const id_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const ms_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const cs_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const el_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const he_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const af_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

const hu_nav_language_tr = /** @type {(inputs: Nav_Language_TrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türkçe`)
};

/**
* | output |
* | --- |
* | "Türkçe" |
*
* @param {Nav_Language_TrInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_tr = /** @type {((inputs?: Nav_Language_TrInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_TrInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_tr(inputs)
	if (locale === "de") return de_nav_language_tr(inputs)
	if (locale === "zh") return zh_nav_language_tr(inputs)
	if (locale === "ar") return ar_nav_language_tr(inputs)
	if (locale === "fr") return fr_nav_language_tr(inputs)
	if (locale === "vi") return vi_nav_language_tr(inputs)
	if (locale === "sw") return sw_nav_language_tr(inputs)
	if (locale === "th") return th_nav_language_tr(inputs)
	if (locale === "bs") return bs_nav_language_tr(inputs)
	if (locale === "ja") return ja_nav_language_tr(inputs)
	if (locale === "ko") return ko_nav_language_tr(inputs)
	if (locale === "pt") return pt_nav_language_tr(inputs)
	if (locale === "it") return it_nav_language_tr(inputs)
	if (locale === "sv") return sv_nav_language_tr(inputs)
	if (locale === "nl") return nl_nav_language_tr(inputs)
	if (locale === "da") return da_nav_language_tr(inputs)
	if (locale === "nb") return nb_nav_language_tr(inputs)
	if (locale === "fi") return fi_nav_language_tr(inputs)
	if (locale === "pl") return pl_nav_language_tr(inputs)
	if (locale === "ru") return ru_nav_language_tr(inputs)
	if (locale === "tr") return tr_nav_language_tr(inputs)
	if (locale === "hi") return hi_nav_language_tr(inputs)
	if (locale === "id") return id_nav_language_tr(inputs)
	if (locale === "ms") return ms_nav_language_tr(inputs)
	if (locale === "cs") return cs_nav_language_tr(inputs)
	if (locale === "el") return el_nav_language_tr(inputs)
	if (locale === "he") return he_nav_language_tr(inputs)
	if (locale === "af") return af_nav_language_tr(inputs)
	if (locale === "hu") return hu_nav_language_tr(inputs)
	return en_nav_language_tr(inputs)
});